import Compose from '@components/shared/Compose';
import ThemeProvider from '@components/theme/ThemeProvider';
import LoginRegisterModalProvider
  from '@components/shared/providers/LoginRegisterModalProvider/LoginRegisterModalProvider';
import ShareModalProvider from '@components/shared/providers/ShareModalProvider/ShareModalProvider';
import ExploreProductModalProvider
  from '@components/shared/providers/ExploreProductModalProvider/ExploreProductModalProvider';
import Shop from '@components/pages/ShopV3/Shop';
import React from 'react';
import AddedToCartConfirmationModalProvider from '@components/shared/providers/AddedToCartConfirmationModalProvider/AddedToCartConfirmationModalProvider';

const ShopPage = (props: any) => (
  <Compose
    components={[
      ThemeProvider,
      LoginRegisterModalProvider,
      ShareModalProvider,
      ExploreProductModalProvider,
      AddedToCartConfirmationModalProvider
    ]}
  >
    <Shop {...props} />
  </Compose>
);

export default ShopPage;
